import React from "react";
import styles from "./Header.module.scss";
import "./Header.scss";
import Header from "../../assets/images/WandaLogoFull.svg";
import MobileHeader from "../../assets/images/WandaLogo.svg";
import { useHistory, useLocation } from "react-router-dom";

export default function CCPHeader() {
  const history = useHistory();
  const { pathname } = useLocation();

  const handleWandaLogo = () =>
    pathname !== "/Welcome" && history.push("/DashBoard");

  return (
    <>
      <div className="headerWrapper">
        <img
          src={Header}
          alt="WandaLogo_Desktop"
          className={styles.headerWanda}
          onClick={handleWandaLogo}
        />
        <img
          src={MobileHeader}
          alt="WandaLogo_Mobile"
          className={styles.headerWandaMobile}
          onClick={handleWandaLogo}
        />
      </div>
    </>
  );
}
